export default __webpack_public_path__ + "static/media/lt.0d13449c.svg";